import SherlockConstant, {
  initialEstateQueryListItemStates,
} from "@/mixins/sherlock/const/sherlockConstant.js";
import SherlockAcConstant from "@/mixins/sherlock/const/sherlockAcConstant.js";
import {
  callGetApi,
  callPostApi,
  callPatchApi,
  callDeleteApi,
} from "@/utils/apiWrapper";

export const state = {
  _estateQueryList: [],
};

export const mutations = {
  [SherlockConstant.SET_SHERLOCK_ESTATE_ESTATE_QUERY_LIST](
    state,
    initialEstateQueryListItemStates
  ) {
    state._estateQueryList = initialEstateQueryListItemStates || [];
  },
};

export const actions = {
  /**************************************************************
   * 다주택 조회 후 그 안에서 등기부 조회
   * owner_property_query_seq, // 다주택조회 seq
   * estate_list, // 등기부 조회할 주소 고유번호 목록.
   **************************************************************/
  async acPostSherlockProcessEstateDocument(
    { commit },
    { owner_property_query_seq, estate_list }
  ) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_DEAL_PROCESS_ESTATE_DOCUMENT}`,
      data: {
        owner_property_query_seq,
        estate_list,
      },
    });
    // window.console.log("[acPostSherlockProcessEstateDocument] res: ", res);
    return res;
  },

  /**************************************************************
   * 단독 등기부등본 조회
   * unique_no_list, // 등기부 조회할 주소 고유번호 목록.
   **************************************************************/
  async acPostSherlockProcessEstateDocumentSeparate(
    { commit },
    { unique_no_list }
  ) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_DEAL_PROCESS_ESTATE_DOCUMENT_SEPARATE}`,
      data: {
        unique_no_list,
      },
    });
    // window.console.log(
    //   "[acPostSherlockProcessEstateDocumentSeparate] res: ",
    //   res
    // );
    return res;
  },

  /**************************************************************
   * 등기소 주소 검색
   * address, // 주소.
   * page = 1, // 페이지.
   **************************************************************/
  async acGetSherlockEstateIrosAddressList({ commit }, { address, page = 1 }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_ESTATE_IROS_ADDRESS_LIST}`,
      params: {
        address,
        page,
      },
    });
    // window.console.log("[acGetSherlockEstateIrosAddressList] res: ", res);
    return res ? res.dataList : null;
  },

  /**************************************************************
   * 다주택 경로로 들어간 것 말고 등기부만 단독으로 조회한 내역들 목록
   **************************************************************/
  async acGetSherlockEstateEstateQueryList({ commit }, { page, pageSize }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_ESTATE_ESTATE_QUERY_LIST}?page=${page}&pageSize=${pageSize}`,
      params: {},
    });
    // window.console.log("[acGetSherlockEstateEstateQueryList] res: ", res);
    commit(
      SherlockConstant.SET_SHERLOCK_ESTATE_ESTATE_QUERY_LIST,
      res?.items || null
    );
    return res;
  },

  /**************************************************************
   * 다주택 경로로 들어간 것 말고 등기부만 단독으로 조회한 내역들 목록
   **************************************************************/
  async acSearchSherlockEstateEstateQueryList({ commit }, { search_keyword }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_ESTATE_ESTATE_QUERY_LIST_SEARCH}?search_keyword=${search_keyword}`,
      params: {},
    });
    // window.console.log("[acSearchSherlockEstateEstateQueryList] res: ", res);
    return res;
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
